import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
const Error = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const time = setTimeout(() => {
      navigate('/logout');
    }, 2000);
    return () => clearTimeout(time);
  }, [navigate]);
  return (
    <div className="h-screen font-montserrat">
      <div className="flex flex-col lg:flex-row justify-center items-center w-full min-h-full bg-asi-blue-background">
        <div className="max-w-[640px] pl-5 pr-5 lg:pr-0">
          <h1 className="my-[15px] lg:my-[30px] text-[46px] sm:text-[54px] font-bold text-asi-black leading-[1]">
            Oops, Something Went Wrong!
          </h1>
          <p className="my-[15px] lg:my-[30px] text-[32px] lg:text-[40px] font-semibold text-asi-black leading-[1.3]">
            Sorry for the inconveniences, please come back later
          </p>
          <small className="my-[15px] lg:my-[30px] text-[20px] lg:text-[24px] text-asi-black block max-w-[500px] leading-[1.3]">
            Status code : 500
          </small>
        </div>
        <img
          className="max-w-[80vw] sm:max-w-[60vw] lg:max-w-[40vw]"
          src="/error_page/oops.png"
          alt="Page Error"
        />
      </div>
    </div>
  );
};

export default Error;
